import React from "react"
import {connect} from "react-redux"
import * as actions from "../../feedback/actions"
import {ButtonLink} from "buoy-core"
import Text from "../../common/components/Text"
import styled from "styled-components"
import {colors} from "buoy-theme"
import { FormattedMessage } from "react-intl"

const getThisIsConfusingVariant = () => {
  // Translate all cases when a/b test is live
  switch (window.this_is_confusing_ab_test) {
    case 2:
      return "Report an issue"
    case 3:
      return "I have feedback"
    case 4:
      return "Give feedback"
    default:
      return (<FormattedMessage id="interview.feedback.confusing" defaultMessage="This is confusing"/>)
  }
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  text-align: right;
  padding: 0;
  margin-bottom: 12px;
`

const Acknowledge = Text.extend.attrs({
  size: "bodyMain",
})`color: ${colors.primary};`

const Space = styled.span`
  margin-left: 16px;
`

const QuestionLink = styled(ButtonLink).attrs({
  color: "neutralDark",
  fontSize: "bodySmall",
})``

const QuestionReport = ({item, getExplanation, setComplaint, ...props}) => {
  if (item.type === "question" || item.type === "clarifier") {
    return (
      <Container className="question-report">
        <QuestionLink onClick={getExplanation}>
          <FormattedMessage
            id="identifiers.age.why"
            defaultMessage="Why am I being asked this?"
          />
        </QuestionLink>
        <Space />
        {item.flagged ? (
          <Acknowledge>Thank you!</Acknowledge>
        ) : (
          <QuestionLink onClick={() => setComplaint(item)}>
            {getThisIsConfusingVariant()}
          </QuestionLink>
        )}
      </Container>
    )
  } else if (item.type === "age" || item.type === "sex" || item.type === "insuranceCapture"
    || item.type === "employerCaptureIntro" || item.type === "employerCaptureInput") {
    return (
      <Container noPadding={item.type === "age"} className="question-report">
        <QuestionLink onClick={getExplanation}>
          {item.type === "sex" ? (
            <FormattedMessage
              id="identifiers.sex.why"
              defaultMessage="Why not more options?"
            />
          ) : (
            <FormattedMessage
              id="identifiers.age.why"
              defaultMessage="Why am I being asked this?"
            />
          )}
        </QuestionLink>
      </Container>
    )
  } else {
    return <div />
  }
}

const mapStateToProps = state => ({
  item: state.chatList.items[state.chatList.active],
})

const mapDispatchToProps = {
  getExplanation: actions.getExplanation,
  setComplaint: actions.setComplaint,
}

const QuestionReportContainer = connect(mapStateToProps, mapDispatchToProps)(
  QuestionReport,
)

export {QuestionReportContainer as default, QuestionReport}



// WEBPACK FOOTER //
// ./assets/interview/components/QuestionReport.js